export const solidBlack = '#000000'
